import { Injector } from '@angular/core';

import { AppConstants } from '../../app.constants';
import { DatesService } from 'src/app/_common/services';
import { RangeKey } from 'src/app/_common/enum';
import { ODataSearch } from 'src/app/_common/api/qs';

export class ODataBckpJobsSearch extends ODataSearch
{
    public datesService: DatesService;

    constructor(searchValue: string, incrSize: number = AppConstants.QSSearchTop)
    {
        super(searchValue, incrSize);

        const injector = Injector.create({ providers: [{ provide: DatesService, deps: [] }] });
        this.datesService = injector.get(DatesService);
        const range = this.datesService.preRangeDates(RangeKey.CURRENT7DAYS);

        this.pushValue('$count', true);

        this.pushValue('since', this.datesService.DateToQueryString(range.since));
        this.pushValue('until', this.datesService.DateToQueryString(range.until));

        // Options de tri
        this.pushValue('$orderby', 'started:desc');

        if (this.searchValue !== null)
        {
            this.searchValue = `${this.searchValue}*`;
            this.pushValue('$search', this.searchValue);
        } else
        {
            const idx = this.values.findIndex((item: { key: string, value: any }) => item.key === '$search');

            this.values = this.values.splice(idx, 1);
        }
    }
}
